module.exports = __webpack_public_path__ + "img/1_x7.a0f300a0.png";